import React, { Component } from "react";
import SendResetLink from "../components/Forms/Auth/PasswordReset/SendResetLink";

export default class SendResetLinkPage extends Component {
    render() {
        return (
            <div>
                <SendResetLink />
            </div>
        );
    }
}
